module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_12.0134b759.mp3";